/*
 * @Author: shannyHuang
 * @Date: 2022-08-04 11:13:21
 * @LastEditors:
 * @LastEditTime: 2022-08-04 14:42:56
 * @FilePath: /wemeet-web-activity/src/model/logout.ts
 */
/**
 * 退出登录，后台set-cookie清空登录态
 */

import { post } from '../lib/http';
import { GetServerSidePropsContext } from 'next';
import { HttpPrefix } from '../lib/wemeet-http-moudle';
import { message } from '@tencent/tea-component';
interface LogoutRes {
  code: number;
  message: string;
  nonce: string;
}

// 退出登录
const logout = async (ctx?: GetServerSidePropsContext) => {
  try {
    const response = await post<LogoutRes>(
      HttpPrefix.WEMEET_WEB_API,
      '/v2/account/logout',
      {},
      ctx,
    );
    return response;
  } catch (e) {
    console.error('request error', e);
  }
  return null;
};

export const logoutPage = (to = '/index.html') => {
  logout()
    .then((res) => {
      if (res.code === 0 && res.data) {
        sessionStorage.clear();
        if (to) {
          window.location.href = to;
        } else {
          window.location.reload();
        }
      } else {
        message.error({ content: '后台服务出错，请重试退出' });
      }
      return res;
    })
    .catch((e) => {
      window.nextAegis.infoAll(e);
    });
};

export default logout;
